import { useFirestoreGeneralOrderBy } from "../../firebase/useFirestore.js";

const ActivityTasksCounter = ({activityFormId}) => {

    // Firestore
    const tasks = useFirestoreGeneralOrderBy('Tasks','ActivityFormID', activityFormId, 'Position', 'asc');

  return (
    <>
     {tasks ? tasks.length : 0} gepland
    </>
  )
}

export default ActivityTasksCounter